import { computed, makeObservable } from 'mobx';

import { inject, injectable } from '@servicetitan/react-ioc';
import {
    MarketingMfe,
    MarketingRouteStore,
    MarketingSection,
    MfeBasenames,
} from '@servicetitan/marketing-global-route';
import { StandaloneRootStore } from '@servicetitan/standalone-root';

import { AppStore } from '../../common/stores/app.store';

@injectable()
export class SuppressionStore {
    basename = this.routeStore.getPathnameWithStandaloneRoot(
        MarketingSection.Apps,
        MfeBasenames[MarketingMfe.Suppression],
    );
    @computed get source() {
        return `https://unpkg.servicetitan.com/@servicetitan/marketing-suppression-fe@${this.standaloneRootStore.appSettings.environmentTag}`;
    }

    @computed get data() {
        // can set different mfeBaseUrl for local development
        return {
            ...this.appStore.defaultMFEData,
            mfeBaseUrl: '',
        };
    }

    constructor(
        @inject(AppStore) private readonly appStore: AppStore,
        @inject(StandaloneRootStore) private readonly standaloneRootStore: StandaloneRootStore,
        @inject(MarketingRouteStore) private readonly routeStore: MarketingRouteStore,
    ) {
        makeObservable(this);
    }
}
